// @ts-strict-ignore
import type { ReactElement, ReactNode } from "react";
import { useState, useCallback } from "react";

import { BannersContext } from "./BannersContext";

interface Props {
  children: ReactNode;
}

const BannersProvider = ({ children }: Props) => {
  const [banners, setBanners] = useState<any>([]);
  const [bannersHeight, setBannersHeight] = useState<number>(0);

  const createBanner = useCallback((bannerId: string, content: ReactElement) => {
    return setBanners(state => [...state, { key: bannerId, content }]);
  }, []);

  const removeBanner = useCallback(key => {
    setBanners(state => state.filter(i => i.key !== key));
  }, []);

  return (
    <BannersContext
      value={{
        banners,
        bannersHeight,
        setBannersHeight,
        createBanner,
        removeBanner,
      }}
    >
      {children}
    </BannersContext>
  );
};

export { BannersProvider };
